import { Route, Routes } from "react-router-dom";
import AddSCMPO from "./AddSCMPO";
import SCMPurchaseOrderList from "./SCMPurchaseOrderList";
import PODetails from "./PODetails";

const SCMPurchaseOrderManagement = () => 
    <Routes>
      <Route path="add" element = {<AddSCMPO />}/>
      <Route path="/" element={<SCMPurchaseOrderList />} /> 
      <Route path="details/:id" element={<PODetails />}/>
    </Routes>

export default SCMPurchaseOrderManagement;
